var win = typeof window !== undefined && window,
  doc = typeof document !== undefined && document,
  docElem = doc && doc.documentElement

const FULLSCREENCHANGE_EVENTS = [
  'webkitfullscreenchange',
  'msfullscreenchange',
  'fullscreenchange'
]

export default {
  hasClass(el, cls) {
    if ('classList' in el) {
      return el.classList.contains(cls)
    }
    return (new RegExp('(\\s|^)' + cls + '(\\s|$)')).test(el.className)
  },
  addClass(el, cls) {
    if ('classList' in el) {
      el.classList.add(cls)
    } else {
      if (!this.hasClass(el, cls)) { el.className += ' ' + cls }
    }
  },
  removeClass(el, cls) {
    if ('classList' in el) {
      el.classList.remove(cls)
    } else {
      if (this.hasClass(el, cls)) {
        el.className = el.className.replace(new RegExp('(\\s|^)' + cls + '(\\s|$)'), ' ').replace(/\s+$/, '')
      }
    }
  },
  removeElement(el) {
    if (!el.parentNode) {
      return el
    }
    return el.parentNode.removeChild(el)
  },
  getClosest(el, selector) { // pulled from https://gomakethings.com/climbing-up-and-down-the-dom-tree-with-vanilla-javascript/
    if (!el) {
      return null
    }
    // Get closest match
    for (; el && el !== document; el = el.parentNode) {
      if (el.matches(selector)) {
        return el
      }
    }
    return null
  },
  getFirstTextNode(el) {
    if (!el || !el.childNodes || !el.childNodes.length) {
      return null
    }
    for (var i = 0, len = el.childNodes.length; i < len; i++) {
      if (el.childNodes[i].nodeType === Node.TEXT_NODE) {
        return el.childNodes[i]
      }
    }
    return null
  },
  getStyle(el, prop) {
    if (win.getComputedStyle) {
      return doc.defaultView.getComputedStyle(el, null).getPropertyValue(prop)
    }
    return null
  },
  getPosition(el) {
    var pos = {
      left: 0,
      top: 0,
      width: 0,
      height: 0
    }
    if (el.getBoundingClientRect) {
      var rect = el.getBoundingClientRect()
      var pageXOffset = win.pageXOffset
      var pageYOffset = win.pageYOffset
      var leftBorderWidth = docElem.clientLeft || 0
      var topBorderWidth = docElem.clientTop || 0
      var leftBodyOffset = 0
      var topBodyOffset = 0
      if (this.getStyle(doc.body, 'position') === 'relative') {
        var bodyRect = doc.body.getBoundingClientRect()
        var htmlRect = docElem.getBoundingClientRect()
        leftBodyOffset = bodyRect.left - htmlRect.left || 0
        topBodyOffset = bodyRect.top - htmlRect.top || 0
      }
      pos.left = rect.left + pageXOffset - leftBorderWidth - leftBodyOffset
      pos.top = rect.top + pageYOffset - topBorderWidth - topBodyOffset
      pos.left = rect.left
      pos.top = rect.top
      pos.width = 'width' in rect ? rect.width : rect.right - rect.left
      pos.height = 'height' in rect ? rect.height : rect.bottom - rect.top
    }
    return pos
  },
  hasFocus(el) {
    return document.activeElement === el
  },
  selectAllText(el) {
    var range, selection
    if (!el) {
      return
    } else if (/^(INPUT|TEXTAREA)$/i.test(el.nodeName)) {
      el.focus()
      el.select()
    } else if (typeof doc.body.createTextRange === 'function') { // IE or Opera <10.5
      range = doc.body.createTextRange()
      range.moveToElementText(el)
      range.select()
    } else if (typeof win.getSelection === 'function') {
      selection = win.getSelection()
      if (typeof selection.setBaseAndExtent === 'function') {
        // Safari
        selection.setBaseAndExtent(el, 0, el, 1)
      } else if (typeof selection.addRange === 'function' && typeof selection.removeAllRanges === 'function' && typeof doc.createRange === 'function') {
        // Mozilla or Opera 10.5+
        range = doc.createRange()
        range.selectNodeContents(el)
        selection.removeAllRanges()
        selection.addRange(range)
      }
    }
  },
  getViewportW() {
    var a = docElem.clientWidth, b = win.innerWidth
    return a < b ? b : a
  },
  getViewportH() {
    var a = docElem.clientHeight, b = win.innerHeight
    return a < b ? b : a
  },
  requestFullscreen() {
    const docElm = document.documentElement
    if (docElm.requestFullscreen) {
      docElm.requestFullscreen()
    } else if (docElm.webkitRequestFullScreen) {
      docElm.webkitRequestFullScreen()
    } else if (docElm.msRequestFullscreen) {
      docElm.msRequestFullscreen()
    }
  },
  exitFullscreen() {
    if (!document.fullscreenElement) return // skip if not in fullscreen
    if (document.exitFullscreen) {
      document.exitFullscreen()
    } else if (document.webkitCancelFullScreen) {
      document.webkitCancelFullScreen()
    } else if (document.msExitFullscreen) {
      document.msExitFullscreen()
    }
  },
  setOnFullscreenChange(listener) {
    FULLSCREENCHANGE_EVENTS.forEach((eventName) => {
      document.addEventListener(eventName, listener, false)
    })
  },
  clearOnFullscreenChange(listener) {
    FULLSCREENCHANGE_EVENTS.forEach((eventName) => {
      document.removeEventListener(eventName, listener)
    })
  }
}
